import {object, string, infer as zodInfer} from 'zod';

const NAME_MAX_LENGTH = 100;
const EMAIL_MAX_LENGTH = 200;
const MESSAGE_MAX_LENGTH = 2000;

export const contactSchema = object({
  name: string()
    .trim()
    .min(1, 'Enter your name')
    .max(NAME_MAX_LENGTH, `Max ${NAME_MAX_LENGTH} characters`),
  email: string()
    .trim()
    .min(1, 'Enter your email')
    .max(EMAIL_MAX_LENGTH, `Max ${EMAIL_MAX_LENGTH} characters`)
    .email('Your email address is incorrect.'),
  message: string()
    .trim()
    .min(1, 'Enter your message')
    .max(MESSAGE_MAX_LENGTH, `Max ${MESSAGE_MAX_LENGTH} characters`),
});

export type ContactFormValues = zodInfer<typeof contactSchema>;
